import { render, staticRenderFns } from "./CustomTableCards.vue?vue&type=template&id=ec3fdbd4&"
import script from "./CustomTableCards.vue?vue&type=script&lang=js&"
export * from "./CustomTableCards.vue?vue&type=script&lang=js&"
import style0 from "./CustomTableCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports